import { Grid, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography, useMediaQuery } from '@mui/material';
import { Box } from '@mui/system';
import { ReactElement, useEffect, useState } from 'react';
import { format } from 'date-fns';
import historyDetailsIcon from '../../../icons/paymentHistoryDetailsIcon.png';
import { useDispatch, useSelector } from 'react-redux';
import { getAllMaintenanceRequests, selectMaintenanceHistoryCurrentPage, selectMaintenanceState } from '../sagas/MaintenanceSlice';
import { selectResidentDetails } from '../../payments/sagas/residentpaymentsSlice';
import { MaintenanceRequestDto, MaintenanceRequestSearchParamsDTO } from '@inosio/payments-sdk';
import ViewMaintenanceDetailsModal from './ViewMaintenanceDetailsModal';
import SpinnerWithNoConfirmation from '../../../shared/Modal/spinnerWithNoConfirmation';
import MaintenanceHistoryIcon from '../../../icons/MaintenanceHistory.svg';

export default function MaintenanceHistory(): ReactElement {
  const matchesMobile = useMediaQuery('(max-width:600px)');
  const [recordStartIndex, setRecordStartIndex] = useState(0);
  const [rangeSize, setRangeSize] = useState(50);
  const [currentPage, setCurrentPage] = useState(0);
  const maintenanceHistoryDataBook = useSelector(selectMaintenanceHistoryCurrentPage);
  const { MaintenanceRequestFetchResponseDto, isFetchingAllMaintenanceRequests, isMaintenanceRequestCreationSuccess } = useSelector(selectMaintenanceState);
  const [openViewMrModal, setOpenViewMrModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState({} as MaintenanceRequestDto);

  const setSearchPageIndex = (pageNumber: number) => {
    if (!maintenanceHistoryDataBook[pageNumber]) {
      const newIndex = pageNumber * rangeSize;
      setRecordStartIndex(newIndex);
    }
  };

  const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPageNumber: number) => {
    setSearchPageIndex(newPageNumber);
    setCurrentPage(newPageNumber);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setCurrentPage(0);
    setRecordStartIndex(0);
    setRangeSize(parseInt(event.target.value));
  };

  const dispatch = useDispatch();
  const residentDetails = useSelector(selectResidentDetails);

  useEffect(() => {
    if (residentDetails && !isMaintenanceRequestCreationSuccess) {
      dispatch({
        type: getAllMaintenanceRequests.type,
        payload: {
          requesterUuid: residentDetails?.Uuid,
          params: {
            RangeSize: rangeSize,
            StartIndex: recordStartIndex,
          } as MaintenanceRequestSearchParamsDTO,
        },
      });
    }
  }, [dispatch, residentDetails, rangeSize, recordStartIndex, isMaintenanceRequestCreationSuccess]);

  return (
    <Box sx={{ width: '100%', height: '100%' }}>
      <Grid container>
        <Grid item xs={12}>
          <Typography id="tableTitle" sx={{ flex: 1 }}>
            History
          </Typography>
        </Grid>
        {isFetchingAllMaintenanceRequests ? (
          <Grid item xs={12} height="310px" display="flex" justifyContent="center" alignItems="center">
            <SpinnerWithNoConfirmation />
          </Grid>
        ) : maintenanceHistoryDataBook?.[currentPage]?.Rows?.length > 0 ? (
          <>
            <TableContainer
              sx={{
                height: '310px',
                overflow: 'auto',
                '&::-webkit-scrollbar': {
                  width: 7,
                },
                '&::-webkit-scrollbar-track': {
                  boxShadow: `inset 0 0 6px rgba(0, 0, 0, 0.3)`,
                  borderRadius: '24px',
                },
                '&::-webkit-scrollbar-thumb': {
                  backgroundColor: 'darkgrey',
                  borderRadius: '24px',
                },
              }}
            >
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell id="subTitle">Ticket</TableCell>
                    <TableCell id="subTitle">Status</TableCell>
                    {!matchesMobile ? <TableCell id="subTitle">Submitted Date</TableCell> : <></>}
                    {!matchesMobile ? <TableCell id="subTitle">Completed Date</TableCell> : <></>}
                    {!matchesMobile ? <TableCell id="subTitle">Details</TableCell> : <></>}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {maintenanceHistoryDataBook?.[currentPage] &&
                    maintenanceHistoryDataBook?.[currentPage].Rows?.map((row, i) => (
                      <TableRow key={i}>
                        <TableCell id="content">{row.Title}</TableCell>
                        <TableCell id="content">{row.CurrentStatus}</TableCell>
                        {!matchesMobile ? <TableCell id="content">{row?.CreatedDate && format(new Date(row.CreatedDate), 'MM/dd/yyyy')}</TableCell> : <></>}
                        {!matchesMobile ? <TableCell id="content">{row?.CompletedDate && format(new Date(row?.CompletedDate), 'MM/dd/yyyy')}</TableCell> : <></>}
                        {!matchesMobile ? (
                          <TableCell id="content">
                            <IconButton
                              onClick={() => {
                                setOpenViewMrModal(true);
                                setSelectedRow(row);
                              }}
                              sx={{ padding: 0 }}
                            >
                              <img style={{ cursor: 'pointer' }} src={historyDetailsIcon} alt="details-icon" />
                            </IconButton>
                          </TableCell>
                        ) : (
                          <></>
                        )}
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Grid item xs={12}>
              <TablePagination component="div" rowsPerPageOptions={[50, 100, 200]} count={MaintenanceRequestFetchResponseDto?.TotalCount ?? 0} page={currentPage} onPageChange={handleChangePage} rowsPerPage={rangeSize} onRowsPerPageChange={handleChangeRowsPerPage} labelRowsPerPage={'Rows'} />
            </Grid>
          </>
        ) : (
          <Grid item xs={12} height="310px" display="flex" justifyContent="center" alignItems="center" flexDirection="column">
            <img src={MaintenanceHistoryIcon} alt="NoHistory" />
            <Typography
              sx={{
                fontFamily: 'Work Sans',
                fontStyle: 'normal',
                fontWeight: 400,
                fontSize: '14px',
                color: '#14142B',
                marginTop:'2px'
              }}
            >
              History
            </Typography>
          </Grid>
        )}
        <ViewMaintenanceDetailsModal open={openViewMrModal} onClose={() => setOpenViewMrModal(false)} title={selectedRow?.Title} statusHistory={selectedRow?.StatusHistory} />
      </Grid>
    </Box>
  );
}
